import { UserBalanceModel } from '../api/models/payments';

let id = 0;

export function getNextId() {
  return id++;
}

export const getDisplayUserBalance = (userBalance: UserBalanceModel, showCurrency = true) => {
  const { currency, amount, fractionDigits = 2 } = userBalance;
  if (!currency) {
    return '';
  }
  const absAmount = Math.abs(amount);
  const isNegative = amount < 0;
  return `${showCurrency ? `${currency} ` : ''}${isNegative ? '-' : ''}${absAmount.toFixed(fractionDigits)}`;
};
